@use "source/webComponent/theme" as *;

.root {
  width: 100%;
  box-sizing: border-box;
  // margin: 16px 0;
}